import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'appTranslate'
})
export class TranslatePipe implements PipeTransform {
  transform(key: string): string {
    return $localize`:Text for translation:${key}`;
  }
}
